import * as angular from "angular";

let LearnSectionComponent = {
    selector: "vcLearnSection",
    templateUrl: "/angular/components/campaign/learn-section.component.html",
    bindings: {
        page: "=",
    },
    controller: class LearnSectionComponentController {
        // * bindings for typescript compiler *
        public page: number;
        // ************************************

        public step: number = 1;

        public setupSteps = [
            [
                {
                    text: "How to Invite Your Team",
                    subtext: "Learn how to invite team members to Ecanvasser",
                    mediaPlayer: () => this.trustedHTML("6xw3v1sg5z"),
                    mediaID: "6xw3v1sg5z",
                    type: "video",
                    buttonText: "Watch now",
                },
                {
                    text: "Quick-Start Guide to Ecanvasser",
                    subtext: "To help get the most of your account",
                    mediaPlayer: () => this.trustedHTML("89xs810pod"),
                    mediaID: "89xs810pod",
                    type: "video",
                    buttonText: "Watch now",
                },
                {
                    text: "Customizing Your Canvassing App",
                    subtext: "Customize your account to suit your needs",
                    mediaPlayer: () => this.trustedHTML("n9d06tm1zs"),
                    mediaID: "n9d06tm1zs",
                    type: "video",
                    buttonText: "Watch now",
                },
            ],
            [
                {
                    text: "How to Invite Your Team",
                    subtext: "Learn how to invite team members to Ecanvasser",
                    mediaPlayer: () => this.trustedHTML("6xw3v1sg5z"),
                    mediaID: "6xw3v1sg5z",
                    type: "video",
                    buttonText: "Watch now",
                },
                {
                    text: "Understanding Permission Levels",
                    subtext: "How to set access controls for individual users",
                    link: "https://support.ecanvasser.com/en/articles/1040942-understanding-permission-levels",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Understanding Permission Levels.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Onboarding New Users",
                    subtext: "Learn how to onboard and manage users and teams",
                    link: "https://support.ecanvasser.com/en/articles/1001117-users-and-teams#h_623eff9eb8",
                    type: "article",
                    thumbnail: "/img/setup-guide/Onboarding New Users.jpg",
                    buttonText: "Quick read",
                },
            ],
            [
                {
                    text: "How to Import Contacts",
                    subtext:
                        "Learn how to import files and set up your contact database",
                    mediaPlayer: () => this.trustedHTML("21vtqqa3cm"),
                    mediaID: "21vtqqa3cm",
                    type: "video",
                    buttonText: "Watch now",
                },
                {
                    text: "Import Best Practices",
                    subtext:
                        "Prepare your contact data for importing into Ecanvasser",
                    link: "https://support.ecanvasser.com/en/articles/1001109-importing-contacts",
                    type: "article",
                    thumbnail: "/img/setup-guide/Import Best Practices.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Connect External Data Sources",
                    subtext:
                        "Integrate with Salesforce, pull data via API, or use Lead Prospector (US only).",
                    link: "https://support.ecanvasser.com/en/articles/11321396-what-are-my-data-import-options",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Connect External Data Sources.jpg",
                    buttonText: "Explore Options",
                },
            ],
            [
                {
                    text: "Navigating the Web App",
                    subtext:
                        "Learn the ins and outs of the Ecanvasser dashboard",
                    link: "https://support.ecanvasser.com/en/articles/4614961-navigating-around-your-web-application",
                    type: "article",
                    thumbnail: "/img/setup-guide/Navigating the Web App.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Customizing Your Experience",
                    subtext: "Configure and customize your Ecanvasser app",
                    link: "https://support.ecanvasser.com/en/articles/2721045-building-your-customized-canvassing-app",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Customizing Your Experience.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Using the Mobile App",
                    subtext: "How to set up the Ecanvasser Walk App on mobile",
                    link: "https://support.ecanvasser.com/en/articles/2499368-walk-app-getting-started",
                    type: "article",
                    thumbnail: "/img/setup-guide/Using the Mobile App.jpg",
                    buttonText: "Quick read",
                },
            ],
            [
                {
                    text: "Using the Map Tool",
                    subtext:
                        "Learn how to use maps to select territories and plan turf",
                    mediaPlayer: () => this.trustedHTML("3zmao1i8bw"),
                    mediaID: "3zmao1i8bw",
                    type: "video",
                    buttonText: "Watch now",
                },
                {
                    text: "Creating Efficient Turf Plans",
                    subtext:
                        "How to cut turf and assign walk lists to your teams",
                    link: "https://support.ecanvasser.com/en/articles/11137946-best-practices-for-customization#h_5af77b0ca3",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Creating Efficient Turf Plans.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Optimizing Routes",
                    subtext:
                        "Learn how to instantly generate optimal walk or drive routes",
                    link: "https://support.ecanvasser.com/en/articles/8705950-walk-app-route-planning",
                    type: "article",
                    thumbnail: "/img/setup-guide/Optimizing Routes.jpg",
                    buttonText: "Quick read",
                },
            ],
            [
                {
                    text: "How to Create and Edit Interaction Statuses",
                    subtext:
                        "Tailor field interaction statuses to fit your needs",
                    link: "https://support.ecanvasser.com/en/articles/2640816-interaction-statuses",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/How to Create and Edit Interaction Statuses.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Tracking Engagement Effectively",
                    subtext:
                        "How to monitor and manage your campaign engagement",
                    link: "https://support.ecanvasser.com/en/articles/6399104-how-do-i-best-track-analyze-and-then-export-my-data",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Tracking Engagement Effectively.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Using Tags and Notes for Better Insights",
                    subtext:
                        "Learn how to accurately capture and filter the insights you collect",
                    link: "https://support.ecanvasser.com/en/articles/11138431-using-tags-and-notes-for-better-insights",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Using Tags and Notes for Better Insights.jpg",
                    buttonText: "Quick read",
                },
            ],
            [
                {
                    text: "Understanding Field Tracking",
                    subtext:
                        "Learn how to track real-buttonText activity in the field",
                    link: "https://support.ecanvasser.com/en/articles/1000121-your-quick-start-guide-to-ecanvasser",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Understanding Field Tracking.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Setting Up GPS Tracking",
                    subtext:
                        "How to set up and monitor GPS tracking for team members",
                    link: "https://support.ecanvasser.com/en/articles/1000121-your-quick-start-guide-to-ecanvasser",
                    type: "article",
                    thumbnail: "/img/setup-guide/Setting up GPS Tracking.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Analyzing Field Data",
                    subtext:
                        "Learn how to track, analyze, and export your data",
                    link: "https://support.ecanvasser.com/en/articles/1000121-your-quick-start-guide-to-ecanvasser",
                    type: "article",
                    thumbnail: "/img/setup-guide/Analyzing Field Data.jpg",
                    buttonText: "Quick read",
                },
            ],
            [
                {
                    text: "Setting Up a Custom Canvassing App",
                    subtext:
                        "How to customize Ecanvasser for your specific needs",
                    link: "https://support.ecanvasser.com/en/articles/11137946-best-practices-for-customization#h_5af77b0ca3",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Setting Up a Custom Canvassing App.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Creating and Managing Surveys",
                    subtext:
                        "Learn how to create and run surveys in your dashboard",
                    link: "https://support.ecanvasser.com/en/articles/1017071-surveys",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Creating and Managing Surveys.jpg",
                    buttonText: "Quick read",
                },
                {
                    text: "Using Custom Scripts for Canvassing",
                    subtext:
                        "Create custom scripts to guide team interactions in the field",
                    link: "https://support.ecanvasser.com/en/articles/1020764-talking-points",
                    type: "article",
                    thumbnail:
                        "/img/setup-guide/Using Custom Scripts for Canvassing.jpg",
                    buttonText: "Quick read",
                },
            ],
        ];

        public steps: any;

        private $sce: any;
        private $scope: any;
        private $timeout: any;
        private $window: any;

        constructor($scope: any, $sce: any, $timeout: any, $window: any) {
            this.$scope = $scope;
            this.$sce = $sce;
            this.$timeout = $timeout;
            this.$window = $window;
        }

        $onInit() {
            let page = this.page ?? 1;
            this.setSteps(page);

            this.$scope.$watch(
                () => this.page,
                (newValue, oldValue) => {
                    if (!!newValue && newValue != oldValue) {
                        this.setSteps(newValue);
                    }
                },
                true
            );
        }

        setSteps(page: number): void {
            this.steps = this.setupSteps[page - 1];
        }

        trustedHTML(mediaID: string): any {
            return this.$sce.trustAsHtml(
                `<wistia-player id="wistia-player-${mediaID}" media-id="${mediaID}" wistia-popover="true" aspect="1.7777777777777777"></wistia-player>`
            );
        }

        launchWistiaPopup(mediaID: string): void {
            const playerEl = document.querySelector(
                `wistia-player[media-id="${mediaID}"]`
            ) as HTMLElement & { shadowRoot?: ShadowRoot };

            if (!playerEl || !playerEl.shadowRoot) {
                console.warn("Wistia player or its shadowRoot not found.");
                return;
            }

            // Access shadow DOM
            const shadowRoot = playerEl.shadowRoot;

            // Find the thumbnail div
            const thumbnail = shadowRoot.querySelector(
                '[id$=".thumbnail"]'
            ) as HTMLElement;

            if (thumbnail && typeof thumbnail.click === "function") {
                thumbnail.click();
            } else {
                console.warn(
                    "Thumbnail inside shadow DOM not found or not clickable."
                );
            }
        }
    },
};

angular
    .module("campaign")
    .component(LearnSectionComponent.selector, LearnSectionComponent);
